<template>
    <div v-show="showPicker" class="zendesk-filepicker">
        <click-outside :handler="close" id="zendesk-filepicker-co" class="fp-popup"
                       style="width: 80%; max-height: 91%; overflow-y: scroll">
            <FilePickerHeader :logo="logo" connector="zendesk" :user="user" :domain="domain" :key="'onedrive'"
                              @close-filepicker="close"/>
            <div class="filepicker-selector-container" v-if="drivesLoading">Loading...</div>
            <div v-else class="filepicker-selector-container" >
                <div style="display: inline-flex; width: 100%;" v-if="drives.length">
                    <div class="filepicker-input-item">
                        <div class="bold">Select Drive</div>
                        <v-select :options="drives"
                                  v-model="selectedDrive"
                                  class="v-select-styling"
                                  label="name"
                                  @input="loadDriveItemChildren"></v-select>
                    </div>
                </div>
            </div>
            <div class="picker-subheader">
                <div class="picker-subheader-text flex">
                    <div>Select Files <span v-if="childDriveItems > 0">&nbsp;({{ childDriveItems.length || 0 }})</span>
                    </div>
                </div>
                <div class="picker-subheader-selected-text">
                    <div>Selected Files <span
                        v-if="selectedChildDriveItems > 0">&nbsp;({{ selectedChildDriveItems.length || 0 }})</span>
                    </div>
                </div>
            </div>
            <div>
            </div>

            <div class="filepicker-body" >
                <div class="picker-search-container">
                    <div>
                        <div class="picker-subheader-text flex">
                            <button class="bbutton"
                                    @click.prevent="(e) => goBack(e)"
                            >
                                < Back
                            </button>
                        </div>
                    </div>
                </div>
                <div class="file-tree">
                    <div class="all-files">
                        <div class="file-picker-tree">
                            <div v-if="this.loadingFiles">
                                Loading...
                            </div>
                            <div v-else class="selected-file"
                                 style="display: block; cursor: pointer"
                                 v-for="(item, k) in childDriveItems"
                                 :key="item.id"

                            >
                                  <span v-if="'folder' in item">
                                      <div style="display: flex; align-items: center;"
                                          @click="(e) => {
                                           if( childDriveItems[k].folder.childCount){
                                              folderSelected(e, childDriveItems[k])
                                            }
                                      }">
                                          <FolderIcon/><span  style="padding-left: 3px">{{ item.name }} ({{childDriveItems[k].folder.childCount}} items)</span>
                                      </div>
                                  </span>
                                  <span v-else-if="'file' in item">
                                      <div @click="(e) => {
                                            fileSelected(e, childDriveItems[k])
                                      }">
                                            <FileIcon/> {{ item.name }}
                                      </div>
                                  </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="selected-files">
                    <div class="file-picker-tree file-tree-no-header">
                        <div class="selected-file" style="list-style: none" v-for="(item, k) in selectedChildDriveItems"
                             :key="k">
                            <div class="article-name zendesk-font-color" :title="item.title">{{ item.name }}</div>
                            <div>
                                <a
                                    @click="fileDeselected($event, item, k)"
                                    type="button" style="cursor: pointer">&nbsp;x
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="filepicker-footer">
                <button class="cancel-btn" id="zendesk-cancel" @click.prevent="cancel">Cancel
                </button>
                <button
                    class="bbutton"
                    id="zendesk-upload-files"
                    :class="submitButtonClass"
                    @click.prevent="upload"
                >
                    {{ submitButtonText }}
                </button>
            </div>
        </click-outside>
        <div class="fp-mask" :style="{ display: showPicker ? 'block' : 'none' }"></div>
    </div>
</template>

<script>
import '../style.scss';
import ClickOutside from 'onclick-outside';
import axios from "axios";
import {reject} from 'lodash';
import FilePickerHeader from "../FilePickerHeader";
import {mapActions, mapGetters, mapState} from "vuex";
import FolderIcon from 'vue-material-design-icons/Folder'
import FileIcon from 'vue-material-design-icons/File.vue'

// TODO break into components
let $token = $("#token");

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if ($token.length) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = $token.attr('content');
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

export default {
    name: "OneDriveFilePicker",
    props: [
        'logo',
    ],
    data() {
        return {
            showPicker: false,
            drivesLoading: true,

            childDriveItems: [],
            selectedChildDriveItems: [],

            // only set when an item has been selected
            currentItem: undefined,

            // for the back button
            parentCache: {},


            drives: [],
            selectedDrive: undefined,

            user: undefined,
            domain: undefined,
            orderId: undefined,

            showPreview: false,
            previewContent: '',
            loadingFiles: false,
            loadedOnce: false,
            loadResult: 'Loading...',
            submitButtonText: 'Upload Files'
        };
    },
    components: {
        FilePickerHeader,
        'click-outside': ClickOutside,
        FolderIcon,
        FileIcon
    },
    watch: {
        showPicker: function (val, oldVal) {
            if (val) {
                this.loadDrives();
            }
        },
    },
    mounted() {
        EventBus.$on("show-onedrive-picker", (data) => {
            this.showPicker = true;
            this.orderId = data?.orderId;
                let $vm = this;
                axios.get(`/connectors/onedrive/picker/user`)
                    .then(response => {
                        this.user = response.data.display_name;
                        this.drivesLoading = false
                    }).catch(function (error) {
                });
            this.loadedOnce = true;
        });
    },
    computed: {
        //counters
        // selectedArticleCount() {
        //     return this.selectedChildDriveItems.length;
        // },
        // articleCount() {
        //     return this.childDriveItems ? Object.values(this.childDriveItems).length : 0;
        // },
        submitButtonClass: function () {
            return {
                'disabled-btn': this.selectedArticleCount === 0,
                'bbutton': this.selectedArticleCount > 0,
            };
        },
        ...mapState({
            source_language: state => state.CreateOrderStore.selectLanguages.source_language,
            uploadFileType: state => state.CreateOrderStore.orderDetails.uploadFileType,
            features: state => state.store.features,
        }),
        ...mapGetters('FeatureFlagStore', {
            'getFeature': 'getFeatureStatusByName'
        }),
    },
    methods: {
        //LOADERS
        loadDrives() {
            this.loadResult = 'Loading...';
            axios.get(`/connectors/onedrive/picker/drives`)
                .then(response => {
                    this.drives = response.data?.value || []
                    // if (!response.data.categories.length) {
                    //   this.loadResult = 'No categories found...';
                    // }
                    // this.categories = response.data.categories;
                }).catch(function (error) {
            });
        },
        loadDriveItemChildren() {
            this.loadingFiles = true;
            this.currentItem = this.selectedDrive
            axios.get(`/connectors/onedrive/picker/drive/${this.selectedDrive.id}/children`)
                .then(response => {
                    this.childDriveItems = response.data.value
                }).catch(function (error) {
                    console.error(error)
                }).finally(() => {
                    this.loadingFiles = false;
            });
        },
        folderSelected(e, folder) {
            if('parentReference' in folder){

                // the parentRef in the first subfolder doesn't
                // adequately give the information that it is a
                // first child, this is how we check that
                // relationship
                if(this.currentItem === this.selectedDrive){
                    this.parentCache[folder.id] = 'parent'
                } else {
                    this.parentCache[folder.id] = folder.parentReference
                }

            }
            this.currentItem = folder
            this.loadingFiles = true;
            axios.get(`/connectors/onedrive/picker/drive/${this.selectedDrive.id}/item/${this.currentItem.id}/children`)
                .then(response => {
                    this.childDriveItems = response.data.value
                    this.loadingFiles = false;
                }).catch(function (error) {
                this.loadingFiles = false;
            });
        },
        goBack() {
            console.log(this.parentCache, this.currentItem)
            if(this.parentCache[this.currentItem.id] === 'parent'){
                this.loadDriveItemChildren();
                this.currentItem = this.selectedDrive
            } else {
                const {id, driveId} = this.parentCache[this.currentItem.id]
                this.loadingFiles = true;
                axios.get(`/connectors/onedrive/picker/drive/${driveId}/item/${id}/children`)
                    .then(response => {
                        this.childDriveItems = response.data.value
                        this.loadingFiles = false;
                    }).catch(function (error) {
                    this.loadingFiles = false;
                });
            }
        },
        fileSelected(e, item) {
            this.selectedChildDriveItems.push(item);
            this.selectedChildDriveItems = [...new Set(this.selectedChildDriveItems)]
            console.log(this.selectedChildDriveItems)
        },
        fileDeselected(index, file, k) {
            this.selectedChildDriveItems = reject(this.selectedChildDriveItems, function (f) {
                return file.id === f.id;
            });
        },
        upload() {

            if (this.selectedChildDriveItems === 0) {
                return;
            }

            this.submitButtonText = 'Loading...';

            let orderId = this.orderId;

            //check if the order id was previously set
            if (!orderId) {
                orderId = $("#order_id").val() === undefined ? 0 : $("#order_id").val(); // TODO
            }

            // add childDriveItems for minified array for sending to backend
            const childDriveItems = []

            for (const [i_, value] of Object.entries(this.selectedChildDriveItems)) {
                childDriveItems.push({
                    name: value.name,
                    id: value.id,
                    section_id: value.section_id,
                    html_url: value.html_url,
                    body: value.body,
                    title: value.title,
                })
            }

            return axios.post('/connectors/onedrive/picker/upload', {
                "onedrive_item_ids": this.selectedChildDriveItems,
                type: this.uploadFileType,
                order_id: orderId,
                drive_id: this.selectedDrive.id

                })
                .then((response) => {
                        console.log(response.data)
                        EventBus.$emit('file-uploaded');
                    }
                ).finally(() => {
                    this.submitButtonText = `Upload`;
                    this.close()
                });

        },
        // cleanup functions
        close() {
            if (!this.showPicker) return;
            this.clearAllTheThings();
            this.showPicker = false;
        },
        cancel(e) {
            this.clearAllTheThings();
            this.showPicker = false;
        },
        //initiate shutdown sequence
        clearAllTheThings() {
            this.selectedChildDriveItems = [];
            this.selectedSection = undefined;
            this.selectedDrive = undefined;
            this.childDriveItems = {};
            this.sections = [];
            this.categories = [];
            this.articlePageCount = 1;
            this.errored = false;
            this.parentCache = []
        },

    },
};
</script>

<style scoped>
.file-tree {
    border-right: 1px solid rgba(60, 60, 60, 0.26);
    width: 50%;
    max-height: 375px;
    overflow: scroll;
    padding: 59px 24px 0;
}
</style>
